import Common from "../../../Common";

export interface PbxSettings {
	name: string
	value?: string
	description?: string
}

const Setting = class extends Common {
	browse = (companyId: id): CustomResponse<PbxSettings[]> =>
		this.get(`/company/${companyId}/pbx/setting`);

	read = (companyId: id, name: string): CustomResponse<PbxSettings> =>
		this.get(`/company/${companyId}/pbx/setting/${name}`);

	create = (companyId: id, data: PbxSettings) =>
		this.post(`/company/${companyId}/pbx/setting`, data);

	delete = (companyId: id, name: string) =>
		this.doDelete(`/company/${companyId}/pbx/setting/${name}`);
}

export default Setting
